import { usePostHog } from 'posthog-js/react';
import { useLocation } from 'react-router';
import { isPHIRoute } from './analytics.utils';
import { sanitizeProperties } from './analytics.utils';

export function useAnalytics() {
  const posthog = usePostHog();
  const location = useLocation();

  const trackEvent = (eventName: string, properties?: Record<string, unknown>) => {
    if (!posthog) return;

    if (isPHIRoute(location.pathname)) {
      return;
    }

    const sanitizedProps = properties ? sanitizeProperties(properties) : undefined;
    posthog.capture(eventName, sanitizedProps);
  };

  const setUserProperties = (properties: Record<string, unknown>) => {
    if (!posthog) return;

    const sanitized = sanitizeProperties(properties);
    delete sanitized.email;
    delete sanitized.name;
    delete sanitized.username;

    posthog.setPersonProperties(sanitized);
  };

  return {
    trackEvent,
    setUserProperties,
    posthog,
  };
}
